jQuery(document).ready(function() {
    jQuery('#testimonys-carousel').owlCarousel({
        items: 5,
        nav: true,
        navText:["&#60","&#62"],
        responsive: {
            0: {
                items: 2
            },
            564: {
                items: 3
            },
            768: {
                items: 4
            },
            1199: {
                items: 5
            }
        }
    });
})